export default "__VITE_ASSET__HHmMPZit__"